module.exports = __webpack_public_path__ + "img/59.6719ad57.png";